<template>
  <div>
    <mdb-card class="grey lighten-5">
      <mdb-card-body>
        <mdb-card-text class="text-center">
          <p class="mt-3">평가를 실시합니다.</p>
          <p>비밀번호를 입력하고 응시하세요</p>
          <mdb-input type="password" label="비밀번호" v-model="password" class="w-25 mx-auto"/>
          <mdb-btn class="py-2" icon="check" @click="onCheck" :disabled="!isEnable"> 응시</mdb-btn>
        </mdb-card-text>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardText } from 'mdbvue';
import Auth from '@/models/Auth'
import { mapState } from 'vuex';

export default {
  name: 'CheckPassword',
  components: { mdbCard, mdbCardBody, mdbCardText },
  props: [],
  data: () => ({
    TAG: 'CheckPassword :',
    password: ''
  }),
  computed: {
    ...mapState('auth', ['profile']),
    isEnable () {
      return this.password
    }
  },
  methods: {
    async onCheck () {
      const result = await Auth.checkPassword(this.profile._id, this.password)
      if (result) {
        this.$emit('success-password')
      } else {
        alert('비밀번호가 일치하지 않습니다.')
      }
    }
  }
}
</script>
